import React from "react";
import { useFormikContext } from "formik"
import { Form } from 'semantic-ui-react'; // tylko w przypadku elementu Form.Input dostępne są te etykiety błędów
import convertError from './ConvertError';

const CheckBox = (props) => {
  const { name, label, ...rest } = props;
  const formik = useFormikContext();
  return (
    <div>
      <Form.Checkbox
        name={name}
        label={label}
        {...rest}
        error = {convertError(formik.touched.rulesChecked, formik.errors.rulesChecked)}
        checked={formik.values.rulesChecked}
        onChange={() => {
          formik.setFieldTouched('rulesChecked');
          formik.setFieldValue('rulesChecked', !formik.values.rulesChecked); 
         }
        }
      />
    </div>
  );
};

export default CheckBox;